module.exports = __webpack_public_path__ + "img/infraestrutura.b373c57e.png";